import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AzyByteTechLanding from './components/AzyByteTechLanding';
import AboutPage from './components/About';
import ServicesPage from './components/Services';
import ContactPage from './components/Contact';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/TermsofService';
import ConsultancyPopup from './components/ConsultancyPopup';
import BlogList from './blogs/BlogList';
import BlogDetail from './blogs/BlogDetail';
import HappyMoments from './pages/HappyMoments';

function App() {
  const hostname=window.location.hostname;
    if (hostname === "happymoments.azybyte.in") {
    return <HappyMoments />;
  }
    return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AzyByteTechLanding />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/happymoments" element={<HappyMoments />} />
          
        </Routes>
      </BrowserRouter>
      <ConsultancyPopup></ConsultancyPopup>
    </div>
  );
}

export default App;